module.exports = __webpack_public_path__ + "img/pet_glasses.de266a06.png";